/** @typedef {import('../../lib/types.js').NoteContentBlock} NoteContentBlock */
import { NOTES_DEMO_CONTENT } from '../notesDemoContent'
import { meetingDemoTranscript } from './meetingDemoTranscript.seed'

/** @type {Record<string, NoteContentBlock[]>} */
export const meetingDemoTabContent = {
  meetingDetail: [
    { type: 'heading', level: 2, text: 'Meeting detail' },
    {
      type: 'paragraph',
      text: 'Product sync · 60 min · Facilitated by Alex Morgan · Launch workstream',
    },
    { type: 'heading', level: 3, text: 'Participants' },
    {
      type: 'bullets',
      items: [
        'Alex Rivera',
        'Jordan Lee',
        'Sam Patel',
        'Taylor Chen',
        'Riley Chen (client)',
        'Guest Vendor',
      ],
    },
  ],
  summary: [
    { type: 'heading', level: 2, text: 'Summary' },
    {
      type: 'paragraph',
      text: 'Consensus on folder-first inbox navigation and a May 28 pilot for Mission Control notes.',
    },
    { type: 'heading', level: 3, text: 'Risks' },
    {
      type: 'bullets',
      items: [
        'Calendar + export scope may expand before GA',
        'Transcript quality from vendor needs follow-up',
      ],
    },
  ],
  transcript: meetingDemoTranscript,
  myNotes: NOTES_DEMO_CONTENT.meetingProductSync,
  chat: [
    { type: 'heading', level: 2, text: 'Chat' },
    {
      type: 'paragraph',
      text: 'Chat with Sia to turn action items into emails, Slack updates, or briefing cards.',
    },
  ],
}
